import * as React from 'react'
import { Link } from 'react-router'

import { Container } from 'components/Layout'
import Page from 'components/Page'
import PageHeader from 'components/Page/PageHeader'
import EmptyMessageCard from 'components/Cards/EmptyMessageCard'
import { Table, TableHeader, TableRow } from 'features/Table'
import { Crumbs } from 'components/BreadCrumbs'
import Button from 'components/Button'
import IconMore from 'components/Icons/More'
import Popover from 'components/Popover/Popover'
import { moment } from 'features/Moment'

import cn from 'classnames'
import * as sText from 'components/Text/Text.scss'
import * as sMarg from 'styles/modules/margins.scss'
import * as sLay from 'styles/modules/layout.scss'
import * as sPopover from 'components/Popover/Popover.scss'
import * as s from './Flows.scss'

export interface IFlowsPageProps {
  getFlows: any
  showFlowCreateModal: any
  confirmDeleteFlow: any
  flows: any
}

const getFlowType = (type: string) => {
  if (type === 'incoming_call') {
    return 'Call'
  } else if (type === 'phone_system_incoming_call') {
    return 'Phone System'
  } else {
    return 'SMS'
  }
}

export default class FlowsPage extends React.Component<IFlowsPageProps> {
  componentWillMount() {
    const { getFlows } = this.props
    getFlows()
  }
  createFlow = () => {
    const { showFlowCreateModal } = this.props
    showFlowCreateModal()
  }
  render() {
    const {
      flows: { flows, flowsLoading, flowsById },
      confirmDeleteFlow,
    } = this.props
    const tableHeader = (
      <TableHeader>
        <div>Name</div>
        <div>Edited</div>
        <div>Published</div>
        <div>Type</div>
        <div style={{ maxWidth: '116px' }} />
      </TableHeader>
    )

    return (
      <Page layout={{ header: 'app' }} title="Flows">
        <PageHeader>
          <Crumbs title="Flows" />
        </PageHeader>
        <Container paddingTop paddingBottom>
          {!flows || flows.length === 0 ? (
            <EmptyMessageCard
              loading={flowsLoading}
              title="You have no Flows"
              subtitle="This feature is in Beta. Best talk to us before you try and use it."
            >
              <Button color="tertiary" size="sm" onClick={this.createFlow} rect>
                Create New Flow
              </Button>
            </EmptyMessageCard>
          ) : (
            <div>
              <div
                className={cn(sMarg.mb30, sLay['layout-row'], sLay['layout-align-start-center'])}
              >
                <div className={cn(sLay.flex, sText.descrip3)}>
                  Note: Unpublished flows do not work.
                </div>
                <Button color="tertiary" size="sm" onClick={this.createFlow} rect>
                  Create New Flow
                </Button>
              </div>
              <Table header={tableHeader}>
                {flows.map(flowId => {
                  const flow = flowsById[flowId]
                  return (
                    <TableRow key={flow.id}>
                      <div>{flow.name}</div>
                      <div>
                        {flow.lastEdited &&
                          moment(flow.lastEdited).format('DD MMM YYYY, h:mm:ss a')}
                      </div>
                      <div>
                        {flow.published
                          ? moment(flow.lastPublished).format('DD MMM YYYY, h:mm:ss a')
                          : 'Never'}
                      </div>
                      <div>{getFlowType(flow.type)}</div>
                      <div style={{ maxWidth: '116px' }}>
                        <Button color="tertiary" size="xs" ghost to={`/dashboard/flows/${flow.id}`}>
                          View
                        </Button>
                        <Popover preferPlace="below" trigger="click">
                          <Button size="xs" style={{ marginLeft: '10px' }} icon>
                            <IconMore size={24} />
                          </Button>
                          <div className={sPopover.popup}>
                            <Link to={`/dashboard/flows/${flow.id}/logs`}>Flow Logs</Link>
                            <a
                              className={
                                flow.type === 'phone_system_incoming_call' ? s.disabled : ''
                              }
                              onClick={() => confirmDeleteFlow(flow.id)}
                            >
                              Delete Flow
                            </a>
                          </div>
                        </Popover>
                      </div>
                    </TableRow>
                  )
                })}
              </Table>
            </div>
          )}
        </Container>
      </Page>
    )
  }
}



// WEBPACK FOOTER //
// src/pages/Flows/Flows.tsx